import React, { useState, useEffect, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Slider from 'react-slick'
import CustomCommonContext from '../../../context/common/commonContext'
import './Banner.css'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'

const Banner = () => {
    // const productCommonContext = useContext(ProductCommonContext)
    const customCommonContext = useContext(CustomCommonContext)

    // const { setSearchValue } = productCommonContext
    const { allHomeBanner } = customCommonContext

    const history = useHistory()
    const settings = {
        dots: false,
        arrows: true,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 6000,
        cssEase: 'linear',
    }

    return (
        <div className="heroCarousel">
            <Slider {...settings}>
                {console.log(allHomeBanner)}
                {allHomeBanner && allHomeBanner.length
                    ? allHomeBanner.map((data, index) =>
                          data.active === 1 ? (
                              <div
                                  className="homeBanner homeMarginBottom"
                                  style={{ width: '100%', height: '400px' }}
                                  key={`banner_${index}`}
                              >
                                  <img
                                      src={`${global.site_url}/uploads/banner/${data.image}`}
                                      onError={(e) => (e.src = './assets/images/banner.png')}
                                      alt={`banner_${index}`}
                                  />
                                  <div className="bannerContent">
                                      <h3>{data.title}</h3>
                                      <h1>{data.description}</h1>
                                  </div>
                              </div>
                          ) : null,
                      )
                    : null}
            </Slider>
        </div>
    )
}

export default Banner
